module.exports = __webpack_public_path__ + "static/media/loyalty-logo.f1169dd9.png";